import React from "react";

import "./Header.css";

const Header = () => {
  return (
    <header>
      <div className="wrapper">
        <h1>StarDB</h1>
      </div>
    </header>
  );
};

export default Header;
